export default "__VITE_ASSET__B_j6PgPQ__"